module.exports = __webpack_public_path__ + "2e08bd6a2dd4274fb6da8906768275c5.gif";